<template>
    <BaseCard :title="'Contact Me'" :highlightLastWord=false>
        <div class="grid lg:grid-cols-2 w-full px-10 lg:gap-40">
            <div class="flex flex-col items-center justify-between w-full">
                <h2>Find Me Here!</h2>
                <div class="mt-4">
                    <span class="contact-icons flex justify-center mb-12 lg:mb-25 overflow-visible gap-[calc(8vw+10px)]">
                        <a href="https://www.linkedin.com/in/clairangelgreen/" target="_blank" alt="My LinkedIn!">
                            <i class="fa-brands fa-linkedin"></i>
                        </a>
                        <a href="https://github.com/cgreen2048" target="_blank" alt="My Github!">
                            <i class="fa-brands fa-github"></i>
                        </a>
                    </span>
                    <span class="contact-icons mb-4 lg:mb-25">
                        <a href="mailto: bgreen8@nd.edu?subject=Email%20From%20Website" alt="Email me at bgreen8@nd.edu!">
                            <i class="fa-solid fa-envelope"></i>
                        </a>
                        <a href="/files/ClairGreenResume.pdf" download="ClairGreenResume.pdf" alt="Download my resume!">
                            <i class="fa fa-file-pdf-o"></i>
                        </a>
                    </span>
                </div>
            </div>
            <div class="flex flex-col items-center w-full"
                :class="submitted ? 'justify-center' : 'justify-between'">
                <h2 class="text-center" :class="{ 'hidden': submitted }">
                    Or Contact Me Directly:
                </h2>

                <div class="flex flex-col items-start justify-start w-full my-4 text-left self-start">
                    <ContactMeForm :submitted="submitted" @toggle-submitted="toggleSubmitted"/>
                </div>
            </div>
        </div>
        
    </BaseCard>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import ContactMeForm from '@/features/components/ContactMe/ContactMeForm.vue';
import BaseCard from '@/features/global/BaseCard.vue';

const submitted = ref(false);
const toggleSubmitted = (): void => {
    submitted.value = !submitted.value;
}
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');


.contact-icons {
    display: flex;
    gap: calc(8vw + 10px); /* Dynamic gap based on viewport width */
    justify-content: center; 
    overflow: visible;
}

.contact-icons i {
    font-size: 80px; 
    transition: transform 0.2s ease-in-out; 
    color: #6a998f; /* Soft muted green */
}


.contact-icons i:hover {
    transform: scale(1.1); 
    color: #90b7a7; /* Softer green on hover */
}

.contact-form {
    text-align: left;
    width: 100%;
}
</style>
